<div bsModal #copyOrMoveToPopup="bs-modal" class="modal fade center-modal z-index-1110"
  id="CopyOrMoveToLocationPopup" tabindex="-1" [config]="{backdrop: 'static', keyboard: false}">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable copy-move-modal-dialog">
    <div class="modal-content copy-move-modal-content bg-pure-white border-2 border-gray-300 rounded-sm overflow-hidden"
      style="box-shadow:0 10px 15px -3px rgba(0,0,0,.1),0 4px 6px -4px rgba(0,0,0,.1);">

      <!-- Sticky header zone (white bg, bottom border) -->
      <div class="flex-shrink-0 bg-white position-relative" style="border-bottom:1px solid #e5e7eb;">
        <!-- Title + description -->
        <div style="padding:16px 24px 12px 24px;padding-right:56px;">
          <h2 class="f-size-16 text-gray-900 mb-0" style="line-height:1.2;">
            {{ isCopy ? 'Copy' : 'Move' }} {{ moveOrCopyItems?.length || 1 }} {{ (moveOrCopyItems?.length || 1) > 1 ? 'items' : 'item' }}
          </h2>
          <p class="f-size-12 text-gray-500 mb-0" style="margin-top:2px;">
            Navigate into the folder you want to {{ isCopy ? 'copy' : 'move' }} to, then click "{{ isCopy ? 'Copy here' : 'Move here' }}".
          </p>
        </div>

        <!-- Tab Switcher -->
        <div style="padding:0 24px 12px 24px;">
          <div class="file-selector-tabs bg-gray-100 rounded-lg p-1" role="group">
            <button type="button" class="d-flex align-items-center rounded-md f-size-14 font-weight-medium border-0 cursor-pointer"
              [ngClass]="isSharePointTab ? 'bg-blue-600 text-pure-white' : 'text-gray-500 hover:text-gray-700'"
              [ngStyle]="!isSharePointTab ? {'background':'transparent'} : {}"
              style="padding:6px 12px;gap:8px;transition:all 0.15s;"
              (click)="switchTab('sharepoint')">
              <lucide-icon name="globe" [size]="16" [strokeWidth]="2"></lucide-icon>
              SharePoint
            </button>
            <button type="button" class="d-flex align-items-center rounded-md f-size-14 font-weight-medium border-0 cursor-pointer"
              [ngClass]="isOneDriveTab ? 'bg-blue-600 text-pure-white' : 'text-gray-500 hover:text-gray-700'"
              [ngStyle]="!isOneDriveTab ? {'background':'transparent'} : {}"
              style="padding:6px 12px;gap:8px;transition:all 0.15s;"
              (click)="switchTab('onedrive')">
              <lucide-icon name="cloud" [size]="16" [strokeWidth]="2"></lucide-icon>
              OneDrive
            </button>
          </div>
        </div>

        <!-- Breadcrumb (gray bg strip) -->
        <div class="d-flex align-items-center flex-wrap bg-gray-50" style="padding:10px 24px;gap:4px;min-height:36px;border-top:1px solid #e5e7eb;">
          <!-- SP breadcrumb from API (level 0 opened via selectedLocation) -->
          <ng-container *ngIf="level === 0 && spBreadcrumb.length > 0">
            <ng-container *ngFor="let crumb of spBreadcrumb; let last = last; let first = first">
              <lucide-icon *ngIf="!first" name="chevron-right" [size]="14" [strokeWidth]="2" class="text-gray-400 flex-shrink-0"></lucide-icon>
              <button class="f-size-14 border-0 bg-transparent p-0 flex-shrink-0"
                [ngClass]="last ? 'font-weight-medium text-gray-900 cursor-default' : 'text-gray-500 hover:text-gray-700 cursor-pointer'">{{crumb.displayName || crumb.name}}</button>
            </ng-container>
          </ng-container>
          <!-- Normal SharePoint breadcrumb (levels 1-5+) -->
          <ng-container *ngIf="isSharePointTab && level !== 0">
            <button class="f-size-14 font-weight-medium border-0 bg-transparent p-0 cursor-default text-gray-900 flex-shrink-0" *ngIf="level === 1">Sites</button>
            <button class="f-size-14 border-0 bg-transparent p-0 cursor-pointer text-gray-500 hover:text-gray-700 flex-shrink-0" *ngIf="level > 1" (click)="backToSelectLocation()">Sites</button>
            <ng-container *ngIf="level >= 2 && selectedSiteData">
              <lucide-icon name="chevron-right" [size]="14" [strokeWidth]="2" class="text-gray-400 flex-shrink-0"></lucide-icon>
              <button class="f-size-14 border-0 bg-transparent p-0 flex-shrink-0"
                [ngClass]="level === 2 ? 'font-weight-medium text-gray-900 cursor-default' : 'text-gray-500 hover:text-gray-700 cursor-pointer'"
                (click)="level > 2 ? goToDrivesBySiteId(selectedSiteData) : null">{{selectedSiteData.displayName}}</button>
            </ng-container>
            <ng-container *ngIf="level >= 3 && selectedDriveData">
              <lucide-icon name="chevron-right" [size]="14" [strokeWidth]="2" class="text-gray-400 flex-shrink-0"></lucide-icon>
              <button class="f-size-14 border-0 bg-transparent p-0 flex-shrink-0"
                [ngClass]="level === 3 ? 'font-weight-medium text-gray-900 cursor-default' : 'text-gray-500 hover:text-gray-700 cursor-pointer'"
                (click)="level > 3 ? goToChildrenOfDrive(selectedDriveData) : null">{{selectedDriveData.name}}</button>
            </ng-container>
            <ng-container *ngIf="level > 4 && selectedItem?.length > 0">
              <ng-container *ngFor="let crumb of selectedItem; let last = last">
                <lucide-icon name="chevron-right" [size]="14" [strokeWidth]="2" class="text-gray-400 flex-shrink-0"></lucide-icon>
                <button class="f-size-14 border-0 bg-transparent p-0 flex-shrink-0"
                  [ngClass]="last ? 'font-weight-medium text-gray-900 cursor-default' : 'text-gray-500 hover:text-gray-700 cursor-pointer'">{{crumb.name}}</button>
              </ng-container>
            </ng-container>
          </ng-container>
          <!-- OneDrive breadcrumb (level 4) -->
          <ng-container *ngIf="isOneDriveTab && level !== 0">
            <button class="f-size-14 border-0 bg-transparent p-0 flex-shrink-0"
              [ngClass]="selectedItem?.length <= 1 ? 'font-weight-medium text-gray-900 cursor-default' : 'text-gray-500 hover:text-gray-700 cursor-pointer'">My OneDrive</button>
            <ng-container *ngIf="selectedItem?.length > 1">
              <ng-container *ngFor="let crumb of selectedItem.slice(1); let last = last">
                <lucide-icon name="chevron-right" [size]="14" [strokeWidth]="2" class="text-gray-400 flex-shrink-0"></lucide-icon>
                <button class="f-size-14 border-0 bg-transparent p-0 flex-shrink-0"
                  [ngClass]="last ? 'font-weight-medium text-gray-900 cursor-default' : 'text-gray-500 hover:text-gray-700 cursor-pointer'">{{crumb.name}}</button>
              </ng-container>
            </ng-container>
          </ng-container>
          <!-- Fallback: level 0 without spBreadcrumb loaded yet -->
          <ng-container *ngIf="level === 0 && spBreadcrumb.length === 0">
            <button class="f-size-14 font-weight-medium border-0 bg-transparent p-0 cursor-default text-gray-900 flex-shrink-0">
              {{ selectedItem?.length > 0 ? selectedItem[selectedItem.length - 1].name : '' }}
            </button>
          </ng-container>
        </div>

        <!-- Close button (absolute top-right) -->
        <button type="button" class="vf-modal-close-btn position-absolute" style="top:16px;right:20px;"
          (click)="close()" aria-label="Close">
          <lucide-icon name="x" [size]="16" [strokeWidth]="2"></lucide-icon>
        </button>
      </div>

      <!-- Scrollable content zone -->
      <div class="flex-1 overflow-hidden d-flex flex-column w-100" style="min-height:0;">
        <div class="flex-1 overflow-hidden bg-white w-100">

          <!-- Search bar -->
          <div class="bg-white flex-shrink-0" style="padding:10px 20px;border-bottom:1px solid #e5e7eb;">
            <div class="d-flex align-items-center gap-8">
              <div class="position-relative flex-1">
                <lucide-icon name="search" [size]="14" [strokeWidth]="2" class="position-absolute text-gray-400" style="left:10px;top:50%;transform:translateY(-50%);pointer-events:none;"></lucide-icon>
                <input type="text" class="w-100 f-size-14 border-0 rounded-sm"
                  style="height:32px;padding-left:32px;padding-right:32px;background:#f3f3f5;outline:none;"
                  placeholder="Search..." [(ngModel)]="currentSearchText" (input)="onSearchInput()" autocomplete="off">
                <button *ngIf="currentSearchText" (click)="clearCurrentSearch()"
                  class="btn btn-link position-absolute text-gray-400 p-0" style="right:8px;top:50%;transform:translateY(-50%);">
                  <lucide-icon name="x" [size]="14" [strokeWidth]="2"></lucide-icon>
                </button>
              </div>
              <button *ngIf="level !== 1 && level !== 2" (click)="toggleNewFolderInput()"
                class="btn d-flex align-items-center gap-6 border border-gray-300 bg-white rounded-sm f-size-14 text-gray-700 font-weight-medium px-12 flex-shrink-0 hover:bg-gray-50"
                style="height:32px;">
                <lucide-icon name="plus" [size]="14" [strokeWidth]="2"></lucide-icon>
                New folder
              </button>
              <input type="file" id="fileUploadOneDrive" style="display: none;" multiple
                (change)="fileInputChanged($event, level === 4, level)" />
            </div>
          </div>

          <!-- New folder inline form -->
          <div *ngIf="isShowNewFolderInput" class="d-flex align-items-center gap-8 bg-white" style="padding:8px 20px;border-bottom:1px solid #e5e7eb;">
            <lucide-icon name="folder" [size]="16" [strokeWidth]="2" class="text-gray-400 flex-shrink-0"></lucide-icon>
            <input id="cmNewFolderInput" type="text" class="f-size-14 border border-gray-300 bg-white rounded-sm flex-1"
              style="height:32px;padding:0 10px;outline:none;"
              placeholder="Folder name" [(ngModel)]="newFolderName" (keydown.enter)="createNewFolderFromInput()" autocomplete="off">
            <button (click)="createNewFolderFromInput()" [disabled]="!newFolderName.trim()"
              class="btn f-size-14 font-weight-medium rounded-sm text-white flex-shrink-0"
              style="height:32px;padding:0 16px;background:#000;">Create</button>
            <button (click)="cancelNewFolderInput()"
              class="btn btn-link text-gray-400 p-0 flex-shrink-0">
              <lucide-icon name="x" [size]="16" [strokeWidth]="2"></lucide-icon>
            </button>
          </div>

          <!-- Loading skeleton -->
          <div *ngIf="isSharePointSitesLoading" class="px-20 py-10">
            <div class="skeleton skeleton-tile mb-2"></div>
            <div class="skeleton skeleton-tile mb-2"></div>
            <div class="skeleton skeleton-tile"></div>
          </div>

          <!-- SharePoint: Sites list (level 1) -->
          <perfect-scrollbar [config]="config" *ngIf="level === 1 && !isSharePointSitesLoading">
            <div role="list" *ngIf="sharePointSitesData.length > 0 && !noSharePointSiteResultFound">
              <button role="listitem" *ngFor="let item of sharePointSitesData"
                class="w-100 d-flex align-items-center text-left hover:bg-gray-50 transition-colors border-0 bg-transparent group"
                style="padding:12px 20px;gap:12px;border-top:1px solid #e5e7eb;"
                (click)="goToDrivesBySiteId(item)">
                <lucide-icon name="globe" [size]="20" [strokeWidth]="2" class="flex-shrink-0" style="color:#64748B;"></lucide-icon>
                <span class="f-size-14 text-gray-900 flex-1 text-truncate">{{item.displayName}}</span>
                <lucide-icon name="chevron-right" [size]="16" [strokeWidth]="2" class="text-gray-300 flex-shrink-0"></lucide-icon>
              </button>
            </div>
            <div *ngIf="noSharePointSiteResultFound && searchTextOnL1 !== ''" class="d-flex align-items-center justify-content-center py-40">
              <p class="f-size-14 text-gray-500 mb-0">We can't find anything matching your search terms.</p>
            </div>
          </perfect-scrollbar>

          <!-- SharePoint: Drives/Libraries list (level 2) -->
          <perfect-scrollbar [config]="config" *ngIf="level === 2 && !isSharePointSitesLoading">
            <div role="list" *ngIf="selectedSiteData?.drives?.length > 0 && !noResultFound">
              <ng-container *ngFor="let item of selectedSiteData.drives">
                <button role="listitem" *ngIf="item.isShow"
                  class="w-100 d-flex align-items-center text-left hover:bg-gray-50 transition-colors border-0 bg-transparent"
                  style="padding:12px 20px;gap:12px;border-top:1px solid #e5e7eb;"
                  (click)="goToChildrenOfDrive(item)">
                  <lucide-icon name="folder" [size]="20" [strokeWidth]="2" class="flex-shrink-0" style="color:#64748B;"></lucide-icon>
                  <span class="f-size-14 text-gray-900 flex-1 text-truncate">{{item.name}}</span>
                  <lucide-icon name="chevron-right" [size]="16" [strokeWidth]="2" class="text-gray-300 flex-shrink-0"></lucide-icon>
                </button>
              </ng-container>
            </div>
            <div *ngIf="isFolderEmpty && !noResultFound" class="d-flex align-items-center justify-content-center my-5">
              <p class="f-size-14 text-gray-500 mb-0">This folder is empty</p>
            </div>
            <div *ngIf="noResultFound" class="d-flex align-items-center justify-content-center my-5">
              <p class="f-size-14 text-gray-500 mb-0">We can't find anything matching your search terms.</p>
            </div>
          </perfect-scrollbar>

          <!-- SharePoint: Drive children (level 3) -->
          <perfect-scrollbar [config]="config" *ngIf="level === 3 && !isSharePointSitesLoading" (psYReachEnd)="getMoreChildrenOfDrive($event)">
            <div role="list" *ngIf="selectedDriveData?.children?.length > 0 && !isFolderEmpty && !noResultFound">
              <ng-container *ngFor="let item of selectedDriveData.children">
                <button role="listitem" *ngIf="item.isShow"
                  class="w-100 d-flex align-items-center text-left transition-colors border-0 bg-transparent"
                  [ngClass]="item.extension === 'folder' ? 'cursor-pointer hover:bg-gray-50' : 'cursor-default'"
                  style="padding:12px 20px;gap:12px;border-top:1px solid #e5e7eb;"
                  (click)="item.extension === 'folder' ? getDriveItems(item) : null">
                  <vf-file-icon [obj]="item" [isSemibold]="true" class="flex-shrink-0"></vf-file-icon>
                  <span class="f-size-14 flex-1 text-truncate"
                    [ngClass]="item.extension === 'folder' ? 'text-gray-900' : 'text-gray-400'">{{item.name}}</span>
                  <span *ngIf="item.lastModifiedDateTime && item.extension !== 'folder'" class="f-size-12 text-gray-400 flex-shrink-0">{{formatDate(item.lastModifiedDateTime)}}</span>
                  <lucide-icon *ngIf="item.extension === 'folder'" name="chevron-right" [size]="16" [strokeWidth]="2" class="text-gray-300 flex-shrink-0"></lucide-icon>
                </button>
              </ng-container>
            </div>
            <div *ngIf="isMoreDataLoading" class="px-20 py-10"><div class="skeleton skeleton-tile"></div></div>
            <div *ngIf="isFolderEmpty && !noResultFound" class="d-flex align-items-center justify-content-center my-5">
              <p class="f-size-14 text-gray-500 mb-0">This folder is empty</p>
            </div>
            <div *ngIf="noResultFound" class="d-flex align-items-center justify-content-center my-5">
              <p class="f-size-14 text-gray-500 mb-0">We can't find anything matching your search terms.</p>
            </div>
          </perfect-scrollbar>

          <!-- OneDrive: My files / sub-folders (level 0 & 4) -->
          <perfect-scrollbar [config]="config" *ngIf="(level === 0 || level === 4) && !isSharePointSitesLoading" (psYReachEnd)="getMoreMyFiles($event)">
            <div role="list" *ngIf="driveItems.length > 0 && !isFolderEmpty && !noResultFound">
              <ng-container *ngFor="let item of driveItems">
                <button role="listitem" *ngIf="item.isShow"
                  class="w-100 d-flex align-items-center text-left transition-colors border-0 bg-transparent"
                  [ngClass]="item.extension === 'folder' ? 'cursor-pointer hover:bg-gray-50' : 'cursor-default'"
                  style="padding:12px 20px;gap:12px;border-top:1px solid #e5e7eb;"
                  (click)="item.extension === 'folder' ? (level === 4 ? onItemSelected(item) : getSelectedLocationItems(item)) : null">
                  <vf-file-icon [obj]="item" [isSemibold]="true" class="flex-shrink-0"></vf-file-icon>
                  <span class="f-size-14 flex-1 text-truncate"
                    [ngClass]="item.extension === 'folder' ? 'text-gray-900' : 'text-gray-400'">{{item.name}}</span>
                  <span *ngIf="item.lastModifiedDateTime && item.extension !== 'folder'" class="f-size-12 text-gray-400 flex-shrink-0">{{formatDate(item.lastModifiedDateTime)}}</span>
                  <lucide-icon *ngIf="item.extension === 'folder'" name="chevron-right" [size]="16" [strokeWidth]="2" class="text-gray-300 flex-shrink-0"></lucide-icon>
                </button>
              </ng-container>
            </div>
            <div *ngIf="isMoreDataLoading" class="px-20 py-10"><div class="skeleton skeleton-tile"></div></div>
            <div *ngIf="isFolderEmpty && !noResultFound" class="d-flex align-items-center justify-content-center my-5">
              <p class="f-size-14 text-gray-500 mb-0">This folder is empty</p>
            </div>
            <div *ngIf="noResultFound" class="d-flex align-items-center justify-content-center my-5">
              <p class="f-size-14 text-gray-500 mb-0">We can't find anything matching your search terms.</p>
            </div>
          </perfect-scrollbar>

          <!-- SharePoint: Deeper folders (level > 4) -->
          <perfect-scrollbar [config]="config" *ngIf="level > 4 && !isSharePointSitesLoading" (psYReachEnd)="getMoreMyFiles($event)">
            <div role="list" *ngIf="driveItems.length > 0 && !isFolderEmpty && !noResultFound">
              <ng-container *ngFor="let item of driveItems">
                <button role="listitem" *ngIf="item.isShow"
                  class="w-100 d-flex align-items-center text-left transition-colors border-0 bg-transparent"
                  [ngClass]="item.extension === 'folder' ? 'cursor-pointer hover:bg-gray-50' : 'cursor-default'"
                  style="padding:12px 20px;gap:12px;border-top:1px solid #e5e7eb;"
                  (click)="item.extension === 'folder' ? getDriveItems(item) : null">
                  <vf-file-icon [obj]="item" [isSemibold]="true" class="flex-shrink-0"></vf-file-icon>
                  <span class="f-size-14 flex-1 text-truncate"
                    [ngClass]="item.extension === 'folder' ? 'text-gray-900' : 'text-gray-400'">{{item.name}}</span>
                  <span *ngIf="item.lastModifiedDateTime && item.extension !== 'folder'" class="f-size-12 text-gray-400 flex-shrink-0">{{formatDate(item.lastModifiedDateTime)}}</span>
                  <lucide-icon *ngIf="item.extension === 'folder'" name="chevron-right" [size]="16" [strokeWidth]="2" class="text-gray-300 flex-shrink-0"></lucide-icon>
                </button>
              </ng-container>
            </div>
            <div *ngIf="isMoreDataLoading" class="px-20 py-10"><div class="skeleton skeleton-tile"></div></div>
            <div *ngIf="isFolderEmpty && !noResultFound" class="d-flex align-items-center justify-content-center my-5">
              <p class="f-size-14 text-gray-500 mb-0">This folder is empty</p>
            </div>
            <div *ngIf="noResultFound" class="d-flex align-items-center justify-content-center my-5">
              <p class="f-size-14 text-gray-500 mb-0">We can't find anything matching your search terms.</p>
            </div>
          </perfect-scrollbar>

        </div>
      </div>

      <!-- Footer (sticky bottom, top border) -->
      <div class="d-flex align-items-center justify-content-end flex-shrink-0 bg-white" style="padding:12px 24px;gap:4px;border-top:1px solid #e5e7eb;">
        <button type="button" (click)="level === 1 ? close() : onGoBack()"
          class="vf-modal-cancel-btn"
          [disabled]="isSaving || isSharePointSitesLoading">
          Cancel
        </button>
        <button type="button" *ngIf="canMoveOrCopy" (click)="onMoveOrCopy()"
          [disabled]="isSaving || isSharePointSitesLoading"
          class="f-size-14 text-white rounded-sm border-0 font-weight-medium"
          style="padding:8px 16px;background:#000;transition:all 0.15s;"
          [style.opacity]="(isSaving || isSharePointSitesLoading) ? '0.4' : '1'"
          [style.cursor]="(isSaving || isSharePointSitesLoading) ? 'not-allowed' : 'pointer'">
          {{ isCopy ? 'Copy here' : 'Move here' }}
        </button>
      </div>
    </div>
  </div>
</div>
<div bsModal #copyOrMoveProgressModal="bs-modal" class="modal fade center-modal trovve-sm-modal z-index-1110" id="CopyOrMoveProgressModal"
  tabindex="-1" [config]="{backdrop: 'static', keyboard: false}">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content box-shadow-popup rounded-12 bg-pure-white border-2 border-gray-300">
      <div class="modal-header d-block p-0 border-0">
        <div class="row mx-0">
          <div class="col px-0">
            <div class="float-right d-flex justify-content-end text-right w-100 h-100">
              <button type="button" class="vf-modal-close-btn" (click)="closeProgressModal()" aria-label="Close">
                <lucide-icon name="x" [size]="16" [strokeWidth]="2"></lucide-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body break-header-border">
        <div class="h-100">
          <div class="row px-3 mb-3">
            <div class="col d-flex pl-0">
              <span *ngIf="!isCopy">Moving {{ moveOrCopyItems?.length }} {{ moveOrCopyItems?.length > 1 ? 'items to' :
                'item to' }} <b>{{ moveOrCopyToLocationName }}</b>
              </span>
              <span *ngIf="isCopy">Copying {{ moveOrCopyItems?.length }} {{ moveOrCopyItems?.length > 1 ? 'items to' :
                'item to' }} <b>{{ moveOrCopyToLocationName }}</b>
              </span>
            </div>
          </div>
          <div class="row mt-10">
            <div class="col">
              <div class="green-grad-progress-bar">
                <div class="progress-segment"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer text-center mb-0">
        <div class="row">
          <div class="col">
            <button type="button" id="cancelCopyMoveProgress" (click)="closeProgressModal()"
              class="vf-modal-cancel-btn">Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<vf-modal-shell #operationErrorShell
  [failure]="true"
  [title]="operationError?.title || (isCopy ? 'Couldn\'t copy this file' : 'Couldn\'t move this file')"
  [message]="operationError?.message"
  [cancelLabel]="operationError?.cancelLabel"
  [saveLabel]="operationError?.saveLabel"
  (cancelClick)="onErrorCancel()"
  (saveClick)="confirmOperationError()">
</vf-modal-shell>
